import React, { Component } from "react"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { injectIntl } from "react-intl"
import DeprecatedCustomerEmailSelect from "../../customer/emailselection.component.jsx"

import GlobalHelper from "../GlobalHelper.jsx"

//Selector to load email addresses an user can use to send their emails
class EmailSelection extends Component {
    constructor(props, context) {
        super(props, context)

        const nylasEmails = AppContext.integrations
            .filter(it => it.attributes.userId === AppContext.getUserLoggedIn().id && it.attributes.configuration.email)
            .map(it => it.attributes.configuration.email)

        this.state = {
            templateKey: this.props.templateKey || "",
            fromEmailError: "",
            fromEmail: this.props.fromEmail || [AppContext.getUserLoggedIn().attributes.email],
            sellerEmail: AppContext.getUserLoggedIn().attributes.email,
            locationId: this.props.locationId || "",
            locationEmail: "",
            companyEmail: "",
            templateDefaultEmail: "",
            nylasEmails: nylasEmails,
            selectedOption: []
        }
        this.onChange = this.props.onChange || function() {}
    }

    componentDidMount() {
        AppContext.getApiClient()
            .get("/accounts/company-descriptions")
            .then(result => {
                this.setState({
                    companyEmail: result.attributes.organization.attributes.email
                })
            })
        if (this.state.locationId) {
            const location = GlobalHelper.getLocationById(this.state.locationId)
            if (location) {
                this.setState({
                    locationEmail: location.attributes.organization.attributes.email
                })
            }
        }

        if (this.state.templateKey) {
            AppContext.getApiClient()
                .get("/templates/" + this.state.templateKey + "/template")
                .then(t => {
                    let nylasEmail = this.state.nylasEmails.length > 0 ? this.state.nylasEmails[0] : ""
                    let propsFromEmail =
                        this.props.fromEmail.length > 0 && this.props.fromEmail[0] !== "" ? this.props.fromEmail : ""
                    let fromEmail = propsFromEmail || t.attributes.defaultFromEmail || nylasEmail || this.state.sellerEmail
                    fromEmail = Array.isArray(fromEmail) ? fromEmail : [fromEmail]
                    this.setState(
                        {
                            fromEmail: fromEmail,
                            templateDefaultEmail: t.attributes.defaultFromEmail
                        },
                        () => {
                            this.onChange(this.state.fromEmail, this.state.fromEmailError)
                        }
                    )
                })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.fromEmail.length !== prevState.fromEmail.length) {
            this.setState({
                fromEmail: this.props.fromEmail || []
            })
            return
        }
        for (let newEmail of this.props.fromEmail) {
            if (!prevState.fromEmail.includes(newEmail)) {
                this.setState({
                    fromEmail: this.props.fromEmail || []
                })
                return
            }
        }
    }

    getAllowedEmailsList() {
        let fromEmail = this.state.fromEmail.length > 0 ? this.state.fromEmail[0] : ""
        let fromEmailList = [
            this.state.sellerEmail,
            this.state.companyEmail,
            this.state.locationEmail,
            this.state.templateDefaultEmail,
            fromEmail
        ]
            .concat(this.state.nylasEmails)
            .filter(email => email)
        let listWithOutDuplicates = [...new Set(fromEmailList)]
        return Array.from(listWithOutDuplicates)
    }

    render() {
        return (
            <DeprecatedCustomerEmailSelect
                name="fromEmail"
                value={this.state.fromEmail}
                onChange={(val, error) => {
                    this.setState(
                        {
                            fromEmail: val,
                            fromEmailError: error
                        },
                        () => {
                            this.onChange(this.state.fromEmail, this.state.fromEmailError)
                        }
                    )
                }}
                id="fromEmail"
                type="text"
                className="form-control"
                allowedEmails={this.getAllowedEmailsList()}
                multi={false}
            />
        )
    }
}

export default injectIntl(EmailSelection)



// WEBPACK FOOTER //
// ./src/common/email/emailselection.component.jsx